<classic-report [report]="this.reportVariant" [reportName]="'Unregistered Learners 8 And 12 Weeks Report'"
  [displayName]="'Unregistered Learners 8 / 12 Weeks Report'" [defaultDisplayColumns]="this.defaultDisplayColumns"
  [dateFilterTypes]="this.dateFilters" [groupByColumns]="this.groupByColumns" [activeLearnerToggle]="false"
  [tableCellStyle]="this.tableCellStyle">
</classic-report>